import { createSlice } from "@reduxjs/toolkit";
import {
  getProvidersDetails,
  addEnquiry,
  getCountryCode,
  getFaqs,
  getLandingDetail,
  submitWebsiteQuery,
} from "../Thunk/providerThunk";

const initialState = {
  isProviderLoading: false,
  data: null,
  error: null,
  userId: null,
  pagination: {
    current_page: 1,
    total_pages: 1,
    total_records: 0,
  },
};

const providerSlice = createSlice({
  name: "providers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProvidersDetails.pending, (state) => {
        state.isProviderLoading = true;
      })
      .addCase(getProvidersDetails.fulfilled, (state, action) => {
        ((state.isProviderLoading = false), (state.data = action.payload.data));
        state.userId = action.payload.data.user_id;
        localStorage.setItem("ngIGj7DweAxsKzOQvMxTJQ3wzjmaGtyD", state.userId);
      })
      .addCase(getProvidersDetails.rejected, (state, action) => {
        ((state.isProviderLoading = false), (state.error = action.payload));
      })
      .addCase(addEnquiry.pending, (state) => {
        state.isProviderLoading = true;
      })
      .addCase(addEnquiry.fulfilled, (state, action) => {
        ((state.isProviderLoading = false), (state.action = action.payload));
      })
      .addCase(addEnquiry.rejected, (state) => {
        state.isProviderLoading = false;
      })
      .addCase(getCountryCode.pending, (state) => {
        state.isProviderLoading = true;
      })
      .addCase(getCountryCode.fulfilled, (state, action) => {
        ((state.isProviderLoading = false), (state.action = action.payload));
      })
      .addCase(getCountryCode.rejected, (state) => {
        state.isProviderLoading = false;
      })
      .addCase(getFaqs.pending, (state) => {
        state.isProviderLoading = true;
      })
      .addCase(getFaqs.fulfilled, (state, action) => {
        ((state.isProviderLoading = false), (state.action = action.payload));
      })
      .addCase(getFaqs.rejected, (state) => {
        state.isProviderLoading = false;
      })
      .addCase(getLandingDetail.pending, (state) => {
        state.isProviderLoading = true;
      })
      .addCase(getLandingDetail.fulfilled, (state, action) => {
        state.isProviderLoading = false;

        const data = action.payload?.data || {};

        state.pagination.current_page = data.current_page;
        state.pagination.total_pages = data.total_pages;
        state.pagination.total_records = data.total_records;
      })
      .addCase(getLandingDetail.rejected, (state) => {
        state.isProviderLoading = false;
      })
      .addCase(submitWebsiteQuery.pending, (state) => {
        state.isProviderLoading = true;
      })
      .addCase(submitWebsiteQuery.fulfilled, (state, action) => {
        ((state.isProviderLoading = false), (state.action = action.payload));
      })
      .addCase(submitWebsiteQuery.rejected, (state) => {
        state.isProviderLoading = false;
      });
  },
});

export default providerSlice.reducer;
